import "core-js/modules/es.array.map.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "app-page flex-col"
};
import { remove } from '@/api/system/post';
import { isOnlyOne } from '@/utils/common';
import { deleteBox, toast } from '@/utils/message';
import { renderAddForm } from './add';
import { renderEditForm } from './edit';
import { searchForm } from './searchForm';
import { createTable } from './table';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Post',
  setup: function setup(__props) {
    var headerRef = ref();
    var tableRef = ref();
    var editFormRef = ref();
    var addFormRef = ref();
    var table = null;
    var search = null;
    var addForm = null;
    var editForm = null;
    onMounted(function () {
      search = searchForm(headerRef.value);
      table = createTable(tableRef.value, {
        rowEdit: rowEdit,
        rowDelete: rowDelete
      }, {
        addFn: addFn,
        editFn: editFn,
        deleteFn: deleteFn
      });
      editForm = renderEditForm(editFormRef.value);
      addForm = renderAddForm(addFormRef.value);
      table.load();
      addForm.onSaveSuccess = function () {
        var _table, _search;
        (_table = table) === null || _table === void 0 || _table.load((_search = search) === null || _search === void 0 ? void 0 : _search.getFormDataNotValidate());
      };
      editForm.onSaveSuccess = function () {
        var _table2, _search2;
        (_table2 = table) === null || _table2 === void 0 || _table2.load((_search2 = search) === null || _search2 === void 0 ? void 0 : _search2.getFormDataNotValidate());
      };
      search.onSearch = function (data) {
        var _table3;
        (_table3 = table) === null || _table3 === void 0 || _table3.load(data);
      };
      search.onReset = function () {
        var _table4;
        (_table4 = table) === null || _table4 === void 0 || _table4.load();
      };
    });
    function rowEdit(row) {
      var _editForm;
      (_editForm = editForm) === null || _editForm === void 0 || _editForm.open(row.id);
    }
    function rowDelete(row) {
      deleteBox().then(function () {
        deleteReq([row.id]);
      });
    }
    /**
     * 表格头部添加
     */
    function addFn() {
      var _addForm;
      (_addForm = addForm) === null || _addForm === void 0 || _addForm.open();
    }
    /**
     * 表格头部编辑
     * @param selects
     */
    function editFn(selects) {
      if (isOnlyOne(selects)) {
        var _editForm2;
        (_editForm2 = editForm) === null || _editForm2 === void 0 || _editForm2.open(selects[0].id);
      }
    }
    /**
     * 表格头部批量删除
     * @param selects
     */
    function deleteFn(selects) {
      deleteBox().then(function () {
        deleteReq(selects.map(function (item) {
          return item.id;
        }));
      });
    }
    /**
     * 删除请求
     */
    function deleteReq(ids) {
      remove(ids).then(function () {
        var _table5, _search3;
        toast.success('删除成功');
        (_table5 = table) === null || _table5 === void 0 || _table5.load((_search3 = search) === null || _search3 === void 0 ? void 0 : _search3.getFormDataNotValidate(), false);
      });
    }
    return function (_ctx, _cache) {
      var _component_XFlexCtx = _resolveComponent("XFlexCtx");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "header",
        ref_key: "headerRef",
        ref: headerRef
      }, null, 512), _createVNode(_component_XFlexCtx, {
        flex: 1
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "table table-content",
            ref_key: "tableRef",
            ref: tableRef
          }, null, 512)];
        }),
        _: 1
      }), _createElementVNode("div", {
        ref_key: "editFormRef",
        ref: editFormRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "addFormRef",
        ref: addFormRef
      }, null, 512)]);
    };
  }
});